import type { RootState } from "@/app/store";
import type { NavigationMenuLayout, SelectedMenuItem } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MenuState {
    selectedMenuItem: SelectedMenuItem,
    navigationMenuLayout: NavigationMenuLayout
}

const initialState: MenuState = {
    selectedMenuItem: 'closed',
    navigationMenuLayout: 'default',
}

export const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setSelectedMenuItem: (state, action: PayloadAction<SelectedMenuItem>) => {
            state.selectedMenuItem = action.payload;
        },
        setNavigationMenuLayout: (state, action: PayloadAction<NavigationMenuLayout>) => {
            state.navigationMenuLayout = action.payload;
        },
    }
})

export const { setSelectedMenuItem, setNavigationMenuLayout } = menuSlice.actions;

export const selectedMenuItem = (state: RootState) => state.menu.selectedMenuItem;
export const navigationMenuLayout = (state: RootState) => state.menu.navigationMenuLayout;

export default menuSlice.reducer;
